<template>
<div>
    <h2 class="text-center">
        {{ title }}
    </h2>
    <table
        class="table-border mx-auto"
    >
        <thead>
            <tr>
                <th>STT</th>
                <th>SỐ PHÒNG</th>
                <th>TIỀN CHƯA THU</th>
                <th>GHI CHÚ</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(payment, index_payment) in payment_data_filter"
                :key="index_payment"
            >
                <td>{{ index_payment + 1}}</td>
                <td>{{ payment.room_id  }}</td>
                <td>{{ payment.diff | formatNumber}}</td>
                <td>{{ payment.note }}</td>
            </tr>
        </tbody>
    </table>
    <div style="break-after: page"></div>
</div>
</template>

<script>
import { roomByBuilding, translateBuildingName } from '../../helpers/helpers';
export default {
    name: "print-danh-sach-no",
    props: {
        payment_data: Array,
        chosen_building: String
    },
    data(){
        return {}
    },
    computed: {
        // computed_building_tables(){
        //     const payment_data_filter = this.payment_data.filter(payment => payment.diff > 0 && !payment.is_approved);

        //     return roomByBuilding(payment_data_filter)
        // }
        payment_data_filter(){
            return this.payment_data.filter(payment => payment.diff > 0 && !payment.is_approved)
        },
        title(){
            let title = "";
            const building_name = translateBuildingName(this.chosen_building)
            title = building_name ? "Danh sách nợ tiền phòng tòa nhà " + building_name : "Danh sách nợ tiền phòng";
            return title.toUpperCase();
        }
    }
};
</script>

<style>
</style>